// Auto-generated
export const widgetsMap = {
    "c-contract-details": () => import('app/widgets/content/c-contract-details/c-contract-details.component'),
    "c-home": () => import('app/widgets/content/c-home/c-home.component'),
    "c-vvi-details": () => import('app/widgets/content/c-vvi-details/c-vvi-details.component')
};
